
<template>
  <!--小区配置-->
  <x-addEdit
    class="community-config"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="expire" slot-scope="{formItem}">
      <a-form-item class="expire" :label="formItem.label" v-bind="{labelCol: { span: 8 }, wrapperCol: { span: 11 }}">
        <a-row type="flex">
          <template v-for="(item, index) of formItem.subList">
            <a-col v-if="item.inputType==='inputNumber'" class="a-col" :key="index">
              <a-form-item class="expire-item" :label="item.label">
                <a-input-number v-if="item.label==='业主'" v-decorator="item.props" :min="item.min" :max="item.max" :disabled="item.disabled"/>
                <a-input-number v-else v-decorator="item.props" :min="item.min" :max="item.max"/>
                <span v-if="item.unit" class="ant-form-text">{{item.unit}}</span>
              </a-form-item>
            </a-col>

            <a-col v-if="item.inputType==='checkboxGroup'" class="a-col" :key="index" >
              <a-form-item class="expire-item" :label="item.label">
                <a-checkbox-group @change="foreverChange" v-decorator="item.props" :options="item.options" :style="{width: '100%'}">
                </a-checkbox-group>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'communityConfig',
  data () {
    let decoratorOptions = {
      community_name: {},
      gate_ring_pattern: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入公共门房号呼叫格式' },
          { min: 6, max: 18, message: this.$store.state.callFormat }
        ]
      },
      ic_mode: {
        rules: [{ required: true, message: '请选择IC卡模式' }]
      },
      is_face: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{ required: true, message: '请选择人脸识别' }]
      },
      owner_time: {
        rules: [
          { required: true, message: '业主期限' },
          { type: 'integer', message: '请输入整数' }
        ]
      },
      is_forever: {
        rules: []
      },
      family_time: {
        rules: [
          {required: true, message: '家属期限'},
          {type: 'integer', message: '请输入整数'}
        ]
      },
      tenant_time: {
        rules: [
          { required: true, message: '租户期限' },
          {type: 'integer', message: '请输入整数'}
        ]
      },
      is_phone_auth: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择电话认证'}]
      },
      is_auto_allote_key: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{ required: true, message: '请选择自动分配钥匙' }]
      },
      is_owner_auth: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{ required: true, message: '请选择是否授权' }]
      }
    };
    return {
      formList: [
        {
          label: '小区名',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['community_name', decoratorOptions.community_name]
        },
        {
          label: '公共门房号呼叫格式',
          inputType: 'input',
          options: [],
          placeholder: '请输入公共门房号呼叫格式',
          help: this.$store.state.callFormat,
          props: ['gate_ring_pattern', decoratorOptions.gate_ring_pattern]
        },
        {
          label: 'IC卡模式',
          inputType: 'select',
          options: [],
          placeholder: '请选择IC卡模式',
          props: ['ic_mode', decoratorOptions.ic_mode]
        },
        {
          label: '人脸识别',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['is_face', decoratorOptions.is_face]
        },
        {
          slot: 'expire',
          label: '房间认证默认期限',
          inputType: 'input',
          subList: [
            {
              label: '业主',
              inputType: 'inputNumber',
              placeholder: '',
              span: 9,
              unit: '月',
              disabled: false,
              props: ['owner_time', decoratorOptions.owner_time]
            },
            {
              label: '',
              inputType: 'checkboxGroup',
              options: [{ label: '永久', value: 1 }],
              placeholder: '',
              props: ['is_forever', decoratorOptions.is_forever]
            },
            {
              label: '家属',
              inputType: 'inputNumber',
              options: [],
              unit: '月',
              placeholder: '',
              span: 9,
              props: ['family_time', decoratorOptions.family_time]
            },
            {
              label: '租户',
              inputType: 'inputNumber',
              options: [],
              unit: '月',
              placeholder: '',
              span: 9,
              props: ['tenant_time', decoratorOptions.tenant_time]
            }
          ]
        },
        {
          label: '电话认证',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['is_phone_auth', decoratorOptions.is_phone_auth]
        },
        {
          label: '自动分配钥匙',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['is_auto_allote_key', decoratorOptions.is_auto_allote_key]
        },
        {
          label: '业主授权',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['is_owner_auth', decoratorOptions.is_owner_auth]
        }
      ],
      formKey: {
        community_name: '',
        gate_ring_pattern: '',
        ic_mode: '',
        is_face: '',
        owner_time: '',
        is_forever: '',
        family_time: '',
        tenant_time: '',
        is_phone_auth: '',
        is_auto_allote_key: '',
        is_owner_auth: ''
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle,
        resHandle: ''
      },
      editParam: {
        url: '/setting/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/setting/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.deviceManageSelect([{index: 2, key: 'ic_card_desc', scope: 'formList'}]);
  },
  methods: {
    /* 永久多选框change */
    foreverChange (val) {
      this.formList.forEach((el) => {
        if (el.slot === 'expire') {
          if (val[0]) {
            el.subList[0].disabled = true;
            this.$children[0].form.setFieldsValue({owner_time: 0});
          } else {
            el.subList[0].disabled = false;
          }
        }
      });
    },
    reqHandle (param) {
      for (let item in param) {
        param[item] === true && (param[item] = 1);
        param[item] === false && (param[item] = 0);
      }
      return param;
    },
    detailResHandle (data) {
      let formValues = {};
      let keyArr = ['is_face', 'is_phone_auth', 'is_auto_allote_key', 'is_owner_auth'];
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
          if (keyArr.some(el => el === item)) {
            data[item] === 1 ? formValues[item] = true : formValues[item] = false;
          }
        }
      }
      if (data.is_forever === 1) {
        formValues.is_forever = [data.is_forever];
        this.formList.forEach((el) => {
          if (el.slot === 'expire') {
            el.subList[0].disabled = true;
          }
        });
      } else {
        formValues.is_forever = [];
      }
      return formValues;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/community/communityConfig.vue